import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { CommonFileUploadModule } from 'src/app/global/common-file-upload/common-file-upload.module';
import { CommonImagesModule } from 'src/app/pages/common-images/common-images.module';
import { CustomFlexLayoutModule } from 'src/app/shared/flex-layout/custom-flex-layout.module';
import { VideoUploadComponent } from '../video-upload/video-upload.component';
import { AudioUploadComponent } from '../audio-upload/audio-upload.component';
import { CoursePdfUploadComponent } from '../course-pdf-upload/course-pdf-upload.component';
import { ImageComponent } from '../image/image.component';

@NgModule({
    declarations: [
        VideoUploadComponent,
        AudioUploadComponent,
        CoursePdfUploadComponent,
        ImageComponent,
    ],
    imports: [
        CommonModule,
        MatButtonModule,
        MatIconModule,
        MatSnackBarModule,
        CommonFileUploadModule,
        CommonImagesModule,
        CustomFlexLayoutModule,
    ],
    exports: [
        VideoUploadComponent,
        AudioUploadComponent,
        CoursePdfUploadComponent,
        ImageComponent,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MediaUploadModule { }
